import React from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'rebass/styled-components';

export const FormBuilderTab = ({ active, icon: Icon, label, onClick }) => (
  <Flex
    onClick={onClick}
    sx={{
      alignItems: 'center',
      gap: '8px',
      px: '8px',
      height: '28px',
      cursor: 'pointer',
      position: 'relative',
      maxWidth: '600px',
    }}
  >
    <Box as={Icon} width="16px" height="16px" sx={{ color: active ? 'text.dark' : 'text.main' }} />
    <Box
      sx={{
        fontSize: '14px',
        fontWeight: active ? '500' : '400',
        color: active ? 'text.dark' : 'text.main',
      }}
    >
      {label}
    </Box>
    {active && (
      <Box
        sx={{
          position: 'absolute',
          bottom: '-1px',
          left: 0,
          right: 0,
          height: '4px',
          bg: 'purple.400',
          borderTopLeftRadius: '4px',
          borderTopRightRadius: '4px',
        }}
      />
    )}
  </Flex>
);

FormBuilderTab.propTypes = {
  active: PropTypes.bool.isRequired,
  icon: PropTypes.elementType.isRequired,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
